<spa-alert [button]="button" [content]="content" [title]="title" (closed)="onClosed()"></spa-alert>
